module.exports = __webpack_public_path__ + "static/images/homelogo3.4f5c9c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homelogo3.png
// module id = X2ax
// module chunks = 0